import { setTxpSettingsDialogViewState } from '../actions/txpSettingsDialogActions';
import { mutator } from 'satcheljs';
import getStore from '../store/store';

export const setTxpSettingsDialogViewStateMutator = mutator(
    setTxpSettingsDialogViewState,
    actionMessage => {
        if (actionMessage.txpSettingsDialogViewStateToSet) {
            Object.keys(actionMessage.txpSettingsDialogViewStateToSet).map(props => {
                getStore().txpSettingsDialogViewState[props] =
                    actionMessage.txpSettingsDialogViewStateToSet[props];
            });
        }
    }
);
